<template>
  <article class="createflow_box" v-if="failureMes">
    <div class="status_icon create_failure"></div>
    <div class="status_title">{{ failureMes }}</div>
    <footer-btn title="返回" @submit="goBack()"></footer-btn>
  </article>
  <article class="create-flow content_process" v-else>
    <div class="content_detail">
      <div class="createflow-car-info" v-if="imageUrl && !isImgError">
        <img :src="imageUrl" alt="" @error="setErrorImg">
        <p class="plate-number"><span class="name">{{ visitsData.plate_number }}</span></p>
      </div>
      <div class="createflow-car-info none-car-pic" v-else>
        <p class="tip-info">{{ isImgError ? '网络错误' : '未抓拍到图片' }}</p>
        <p class="refresh-btn" v-if="isImgError" @click="refreshImg"></p>
        <p class="plate-number"><span class="name">{{ visitsData.plate_number }}</span></p>
      </div>
      <group title="车辆品牌">
        <div class="box">
          <checker
            v-model="brand_id"
            default-item-class="brands-item"
            selected-item-class="brands-item-selected"
            v-if="visitsData">
            <checker-item
              :disabled="!item.is_current_brand && !item.is_self_brand"
              v-for="item in visitsData.brands"
              :key="item.id"
              :class="[item.is_current_brand ? 'brands-item-selected' : '', (!item.is_current_brand && !item.is_self_brand) ? 'brands-item-disabled' : '']"
              :value="item.id"
              @on-item-click="handleOnSelCarBrand(item)"
            >{{ item.name }}</checker-item>
          </checker>
        </div>
      </group>
      <h2 class="title-bar">
        <span>放行流程</span>
        <label class="temporary-release" v-if="(visitsData.has_workshop_rules && visitsData.has_temporary_rules) || ruleDisabled">
          <input type="checkbox" v-model="hasSelectedTemporaryRule" :disabled="ruleDisabled" @change="getData"/>临时放行
        </label>
      </h2>
      <div
        class="change-rule"
        @click="changeRuleStatus"
        v-if="visitsData.exiting_rules.length > 1"
      >{{ ruleTitle }}
      </div>
      <div class="process_list" v-if="visitsData.exiting_rule_steps.length > 0">
        <ul class="flow">
          <li v-for="(item, index) in visitsData.exiting_rule_steps" :key="item.step_no">
            <div class="status_icon">
              <i class="status_line"></i>
              <i class="icon" :class="[0, 1].includes(item.step_no) ? 'status_waiting' : 'original'"></i>
            </div>
            <div class="status_info" @click.stop="onSelect(index, item.step_no)">
              <div v-if="item.step_no === 0">
                <p> {{ '发起人' }} </p>
                <p v-for="(v, i) in item.review_employee_choices" :key="i">{{v.owner_name}}</p>
              </div>
              <div v-if="item.step_no === 1">
                <p>{{ '接待人' }}</p>
                <p v-for="(v, i) in item.review_employee_choices" :key="i">{{v.employee_name}}</p>
              </div>
              <div v-if="item.step_no > 1">
                <p>{{ '选择审核人' }}</p>
                <p v-for="(v, i) in item.selEmployee" :key="i">{{v.employee_name}}</p>
              </div>
              <div class="arrow_right" v-if="item.step_no > 1"></div>
            </div>
          </li>
          <li>
            <div class="status_icon">
              <i class="status_line"></i>
              <i class="icon original"></i>
            </div>
            <div class="status_info">
              <p class="title">已出店</p>
            </div>
          </li>
        </ul>
      </div>
      <group title="放行备注（必填）">
        <cell :title="reason.name" @click.native="handleGetReleaseReason" :bdStart="true" is-link></cell>
        <div class="createflow__img">
          <upload-img v-model="imageList" />
        </div>
        <x-textarea v-model.trim="visitsData.note" :max="120" placeholder="补充说明" :show-counter="true" :height="120"></x-textarea>
      </group>
      <group title="选择放行的客户" v-if="visitsData.customer_choices">
        <radio
          class="sel_customer"
          v-model="visitsData.selCustomer"
          :options="visitsData.customer_choices"
        ></radio>
      </group>
      <!-- 选择审核人弹层 -->
      <popup v-model="showEmployee" style="height: 100%;overflow: auto;">
        <group title="选择审核人">
          <checklist v-model="selEmployeeIds" :options="employeeChoices" label-position="left">
          </checklist>
        </group>
        <toast v-model="selectionAuditor" type="text" :time="1000">至少选择一个审核人</toast>
        <footer-btn title="确定" @submit="onSure"></footer-btn>
      </popup>
      <!-- 选择放行规则弹层 -->
      <popup v-model="showRules" style="height: 100%;overflow: auto;">
        <group :title="visitsData.rule_type_text">
          <div
            class="createflow__rules"
            v-for="item in visitsData.exiting_rules"
            :key="item.rule_id"
            @click="handleRuleClick(item.rule_id)"
          >
            <div style="padding-right:16px;">
              <p class="createflow__rules-name">{{item.rule_name}}</p>
              <p class="createflow__rules-text">{{item.text}}</p>
            </div>
            <input type="radio" v-model="rule_id" :value="item.rule_id" />
          </div>
        </group>
      </popup>
      <!-- 选择放行原因弹层 -->
      <popup v-model="showReasons" style="height: 50%;overflow: auto;">
        <search-input
          v-model="keyword"
          placeholder-word="输入名称快速搜索"
          @input="handleSearchInput"
        />
        <group>
          <cell
            v-for="option in reasonOptions"
            :key="option.id"
            :title="option.name"
            @click.native.capture="handleReasonClick(option)"
          >
            <input type="radio" v-model="reasonId" :value="option.id" />
          </cell>
        </group>
      </popup>
    </div>
    <div class="footer-btn" v-if="isBtnShow">
      <x-button type="primary" class="footer-btn__reject" @click="rejectDialogVisible = true">驳回</x-button>
      <x-button type="primary" class="footer-btn__agree" @click="onSubmit">同意</x-button>
    </div>
    <x-dialog v-model="rejectDialogVisible" class="rejectDialog">
      <p class="rejectDialog__title">确认驳回</p>
      <div class="rejectDialog__content">确定驳回客户的放行申请吗？</div>
      <div class="rejectDialog__buttons">
        <p @click="rejectDialogVisible = false">取消</p>
        <p @click="onReject">确定</p>
      </div>
    </x-dialog>
  </article>
</template>

<script>
import { Group, Cell, XTextarea, Radio, Popup, Checklist, XButton, Toast, checker, checkerItem, XDialog } from '@lx-frontend/cvux'
import FooterBtn from '../components/FooterBtn'
import SearchInput from '../components/SearchInput'
import UploadImg from './UploadImg'

let reasonOptionsCope = []

export default {
  components: { Group, Cell, XTextarea, Radio, Popup, Checklist, XButton, Toast, checker, checkerItem, XDialog, FooterBtn, UploadImg, SearchInput },
  data() {
    return {
      id: 0,
      visitId: 0,
      selectionAuditor: false,
      stepsIndex: 0,
      showEmployee: false,
      selEmployeeIds: [],
      employeeChoices: [],
      showRules: false,
      isTapDone: false, // 防止重复点击
      failureMes: '', // 失败请求
      visitsData: {
        note: '',
        selCustomer: '',
        customer_choices: [],
        exiting_rule_steps: [],
        exiting_rule_id: '',
        exiting_rules: [],
        brands: []
      },
      showReasons: false, // 控制选择放行原因弹窗
      reasonOptions: [],
      queryForm: {
        keyword: ''
      },
      brand_id: '', // 车辆品牌
      rule_id: '', // 规则
      isImgError: false,
      imageUrl: '',
      ruleTitle: '请选择放行规则',
      sucKey: 'barriergate_data_suc', // 发布成功后的sessionKey
      sessionKey: 'barriergate_data', // 进入选择审核人列表的sessionKey
      isBtnShow: true,
      rejectDialogVisible: false,
      hasSelectedTemporaryRule: false, // 是否选择临时放行
      ruleDisabled: false, // 禁用临时放行选择
      imageList: [],
      reason: {
        id: '',
        name: ''
      },
      reasonId: '',
      keyword: ''
    }
  },
  created() {
    this.id = +this.$route.query.requisition_id
    this.getData()
    this.getExitCategories()
  },
  methods: {
    handleReasonClick(reason) {
      this.reason = reason
      this.reasonId = reason.id
      this.showReasons = false
    },

    handleRuleClick(id) {
      this.rule_id = id
      this.showRules = false
      this.getData()
    },

    handleSearchInput(val) {
      if (val) {
        this.reasonOptions = reasonOptionsCope.filter((reason) => {
          return reason.name.includes(val)
        })
      } else {
        this.reasonOptions = reasonOptionsCope
      }
    },

    handleGetReleaseReason() {
      this.showReasons = true
      this.keyword = ''
      this.reasonOptions = reasonOptionsCope
    },

    // 选择车辆品牌
    handleOnSelCarBrand(item) {
      this.rule_id = ''
      this.brand_id = item.id || ''
      this.getData()
    },

    /**
     * 获取放行备注列表
     */
    async getExitCategories() {
      const { code, data } = await this.$rest.barriergate.getExitCategories()
      if (code === 0) {
        const list = data.exit_categories
        const ids = list.map((item) => item.id)
        const selectIds = (JSON.parse(localStorage.getItem('create_flow_select_reason_ids')) || [])
          .filter((id) => ids.includes(id))

        selectIds.forEach((id) => {
          list.forEach((item, index) => {
            if (item.id === id) {
              list.splice(index, 1)
              list.unshift(item)
            }
          })
        })

        this.reasonOptions = reasonOptionsCope = list
        this.reason = list[0]
        this.reasonId = list[0].id
      }
    },

    getData() {
      this.$rest.barriergate.getEntryPermitInfo(this.id)({
        brand_id: this.brand_id,
        exiting_rule_id: this.rule_id,
        has_selected_temporary_rule: this.isSelectedTemporaryRule
      }).then(res => {
        if (res.code !== 0) {
          this.failureMes = res.message
        }
        let data = res.data
        this.imageUrl = data.image_url
        this.visitId = data.visit_id
        // 当车辆已经进入车间且当前操作人不是车间规则发起人，仅是临时放行规则发起人时页面显示临时放行勾选框，且默认勾上不可编辑
        if (!data.has_workshop_rules && data.has_temporary_rules) {
          this.hasSelectedTemporaryRule = true
          this.ruleDisabled = true
        }
        this.ruleTitle = data.exiting_rule_steps.length > 0 ? '更换放行规则' : '请选择放行规则'

        data.brands.map(res => {
          if (res.is_current_brand) {
            this.brand_id = res.id === null ? '' : res.id
          }
        })

        if (data.exiting_rules.length === 1) {
          this.rule_id = data.exiting_rules[0].rule_id
        }

        data.exiting_rule_steps.forEach(v => {
          v.selEmployee = []
          v.selEmployeeIds = []
        })

        if (data.exiting_rule_steps[0]) {
          // 发起人默认选中
          let firstOne = data.exiting_rule_steps[0].review_employee_choices
          data.exiting_rule_steps[0].selEmployee = firstOne
          data.exiting_rule_steps[0].selEmployeeIds = [firstOne[0].employee_id]
        }

        // 重构客户数组
        if (data.customer_choices) {
          data.customer_choices = data.customer_choices.map(v => {
            return {
              key: v.customer_id + '',
              value: v.customer_name
            }
          })
          data.selCustomer = ''
        }
        data.note = ''
        this.visitsData = data
      })
    },
    // 选择审核人
    onSelect(index, stepNo) {
      if (stepNo > 1) {
        let list = []
        let employeeList = this.visitsData['exiting_rule_steps'][index]['review_employee_choices']
        employeeList.forEach(v => {
          list.push({
            key: +v.employee_id,
            value: v.employee_name
          })
        })
        this.stepsIndex = index
        this.employeeChoices = list
        this.selEmployeeIds = this.visitsData['exiting_rule_steps'][index]['selEmployeeIds']
        this.showEmployee = true
      }
    },
    // 确定选择审核人
    onSure() {
      if (!this.selEmployeeIds.length) {
        this.selectionAuditor = true
        return
      }
      let ruleSteps = this.visitsData['exiting_rule_steps'][this.stepsIndex]
      if (ruleSteps) {
        let employeeList = ruleSteps.review_employee_choices
        ruleSteps['selEmployee'] = employeeList.filter(v => {
          return this.selEmployeeIds.indexOf(v.employee_id) > -1
        })
        ruleSteps['selEmployeeIds'] = this.selEmployeeIds
      }
      this.showEmployee = false
    },

    // 提交审核
    async onSubmit() {
      // let nParams = {}
      let params = {}
      if (this.isTapDone) {
        return false
      }

      params.visit_id = +this.visitsData.visit_id
      params.exiting_rule_id = +this.rule_id
      params.customer_id = this.visitsData.customer_choices ? +this.visitsData.selCustomer : null
      params.steps = []
      params.brand_id = +this.brand_id
      params.exit_category_id = +this.reasonId

      // 是否选择放行规则
      if (!params.exiting_rule_id) {
        this.showToast(`请选择放行规则`)
        return
      }
      // 步骤列表检查
      let noReviewer = this.visitsData.exiting_rule_steps.find((v, index) => {
        return (index === 2) && (!v.selEmployee || v.selEmployee.length === 0)
      })
      if (noReviewer) {
        this.showToast('请选择审核人')
        return false
      }
      // 拼接表单
      this.visitsData.exiting_rule_steps.forEach(item => {
        let step = {}
        if (item.step_no !== 0) {
          step.rule_step_id = +item.step_id
          step.step_no = +item.step_no
          step.title = item.title
          step.review_employee_ids = item.step_no > 1 ? item.selEmployeeIds : [item.review_employee_choices[0].employee_id]
          params.steps.push(step)
        }
      })

      params.remark = this.visitsData.note
      params.has_selected_temporary_rule = +this.isSelectedTemporaryRule

      this.isTapDone = true
      this.switchLoading({ status: true, text: '加载中...' })

      // 上传图片
      if (this.imageList.length) {
        const mediaIds = await Promise.all(this.imageList.map((localId) => {
          return new Promise((resolve) => {
            this.$wechat.wx.uploadImage({
              isShowProgressTips: 0,
              localId,
              success: (res) => resolve(res.serverId),
              fail: () => {
                this.switchLoading({ status: false })
                this.showToast('图片上传失败，请稍后重试')
                this.isTapDone = false
              }
            })
          })
        }))
        const { code, data, message } = await this.$rest.barriergate.uploadWorkflowImages({ media_ids: mediaIds })
        if (code === 0) {
          params.image_urls = JSON.stringify(data.image_urls)
          this.submit(params)
        } else {
          this.switchLoading({ status: false })
          this.showToast(message || '网络异常，请稍后重试')
          this.isTapDone = false
        }
      } else {
        this.submit(params)
      }
    },

    async submit(params) {
      const { code, message } = await this.$rest.barriergate.createFlow(params, `${this.visitId}/exiting/process/start?brand_id=${this.brand_id}&requisition_id=${this.id}`)

      this.switchLoading({ status: false })
      this.isTapDone = false

      if (code === 0) {
        // 选择的放行备注保存到 storage
        let selectReasonList = JSON.parse(localStorage.getItem('create_flow_select_reason_ids')) || []
        if (selectReasonList.includes(this.reasonId)) {
          selectReasonList.splice(selectReasonList.indexOf(this.reasonId), 1)
        }
        selectReasonList.push(this.reasonId)
        selectReasonList = selectReasonList.slice(-3)
        localStorage.setItem('create_flow_select_reason_ids', JSON.stringify(selectReasonList))

        // 跳转到成功页面
        this.$router.push(`/barriergate/create/succ/${this.sucKey}`)
      } else {
        this.showToast(message)
      }
    },

    // 放行驳回
    async onReject() {
      const res = await this.$rest.barriergate.rejectEntryPermit({ requisition_id: +this.id })
      this.rejectDialogVisible = false
      if (res.code === 0) {
        this.isBtnShow = false
      } else {
        this.showToast(res.message)
      }
    },
    goBack() {
      this.$router.go(-1)
    },
    // 选择请选择放行规则或更换放行规则,显示放行规则列表
    changeRuleStatus () {
      this.showRules = true
    },
    setErrorImg () {
      this.isImgError = true
    },
    refreshImg () {
      this.imageUrl = this.visitsData.image_url
      this.isImgError = false
    }
  },
  computed: {
    isSelectedTemporaryRule () {
      return (!this.visitsData.has_workshop_rules && this.visitsData.has_temporary_rules) ? 1 : +this.hasSelectedTemporaryRule
    }
  }
}

</script>
<style lang="less">
@import "../../stylesheets/modules/barriergate/creatFlow.less";
@import "../../stylesheets/modules/components/flow.less";
.footer-btn{
  display: flex;
  position: absolute;
  justify-content: space-between;
  width: 100%;
  line-height: 96/@w2;
  left: 0;
  bottom: 10/@w2;
  border-radius: 0;
  font-size: 29/@w2;

  &__agree{
    width: 40%!important;
  }

  &__reject{
    width: 40%!important;
    background: transparent;
    color: #000;
    overflow: visible;
  }
}

.rejectDialog {
  &__title {
    font-size: 34/@w2;
    padding: 34/@w2 0 38/@w2;
  }

  &__content {
    padding: 0 46/@w2;
    color: #555;
    padding-bottom: 84/@w2;
    text-align: center;
  }

  &__buttons {
    height: 100/@w2;
    line-height: 100/@w2;
    display: flex;
    font-size: 30/@w2;
    color: #333;
    border-top: 1/@w2 solid #eee;
    p {
      flex: 1;
      &:first-child {
        border-right: 1/@w2 solid #eee;
      }
      &:active {
        opacity: .7;
      }
    }
  }
}
</style>
